module.exports = __webpack_public_path__ + "img/mostar.090af8ad.png";